<!-- Component Container (Fits into form) -->
<div class="card shadow-sm">
  
  <!-- Compact Header / Configuration -->
  <div class="card-header py-2">
    <div class="row g-2 align-items-center">
      <div class="col-auto">
        <input 
          type="text" 
          inputmode="decimal"
          class="form-control form-control-sm"
          style="width: 170px;"
          [(ngModel)]="rangeMin"
          (ngModelChange)="updateRangeMin($event)">
      </div>
      <div class="col text-center text-secondary small user-select-none">
        Scale
      </div>
      <div class="col-auto">
        <input 
          type="text" 
          inputmode="decimal"
          class="form-control form-control-sm text-end"
          style="width: 170px;"
          [(ngModel)]="rangeMax"
          (ngModelChange)="updateRangeMax($event)">
      </div>
    </div>
  </div>

  <div class="card-body p-3">
    
    <!-- Gradient Bar & Track Container -->
    <div class="position-relative mb-2">
      
      <!-- Gradient Bar -->
      <div 
        class="gradient-bar rounded border"
        [style.background]="gradientString">
      </div>

      <!-- Interactive Track -->
      <div 
        class="track-area mt-2 position-relative"
        #trackRef
        (mousedown)="onTrackClick($event)">
        
        <!-- Track Line -->
        <div class="track-line position-absolute w-100 rounded-pill bg-secondary"></div>

        <!-- Stops -->
        <div *ngFor="let stop of stops" 
          class="stop-marker position-absolute d-flex flex-column align-items-center"
          [style.left.%]="stop.position"
          (mousedown)="onStopMouseDown($event, stop.id)"
          (click)="$event.stopPropagation()">
          
          <!-- Value Label (Compact) -->
          <span class="stop-label badge bg-light text-dark mb-1 p-1">
            {{ stop.number }}
          </span>

          <!-- Arrow -->
          <div 
            class="arrow-down"
            [class.active]="selectedStopId === stop.id">
          </div>

          <!-- Handle -->
          <div 
            class="stop-handle rounded-circle shadow-sm border border-2"
            [style.background-color]="stop.color"
            [class.border-primary]="selectedStopId === stop.id"
            [class.border-secondary]="selectedStopId !== stop.id"
            [class.active-ring]="selectedStopId === stop.id">
          </div>
        </div>
      </div>
    </div>

    <!-- Compact Editor Toolbar -->
    <div class="mt-4 pt-2 border-top">
      <div *ngIf="activeStop as stop" class="row g-2 align-items-center animate-fade">
        <!-- Color -->
        <div class="col-auto">
          <div class="input-group input-group-sm">
            <input 
              type="color" 
              class="form-control form-control-color p-1" 
              [(ngModel)]="stop.color"
              (ngModelChange)="updateStopColor($event)"
              title="Color">
            <input 
              type="text" 
              class="form-control"
              style="width: 80px;"
              [value]="stop.color"
              readonly>
          </div>
        </div>

        <!-- Value -->
        <div class="col-auto">
          <div class="input-group input-group-sm">
            <span class="input-group-text">Val</span>
            <input 
              type="text" 
              inputmode="decimal"
              class="form-control fw-bold"
              style="width: 200px;"
              [(ngModel)]="stop.number"
              (ngModelChange)="updateStopValue(stop.id, $event)">
          </div>
        </div>

        <!-- Label -->
        <div class="col-auto">
          <div class="input-group input-group-sm">
            <span class="input-group-text">Label</span>
            <input 
              type="text" 
              class="form-control"
              style="width: 200px;"
              [(ngModel)]="stop.label"
              (ngModelChange)="updateStopLabel(stop.id, $event)"
              placeholder="Label (optional)">
          </div>
        </div>

        <!-- Actions -->
        <div class="col text-end">
          <button 
            class="btn btn-danger btn-sm"
            [disabled]="stops.length <= 2"
            (click)="deleteStop(stop.id)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
      <div *ngIf="!activeStop" class="text-muted small fst-italic py-1">
        Click stop to edit
      </div>
    </div>

  </div>
</div>